import classNames from "classnames";
import { useSelector } from "redux/hooks";
import { FormattedMessage, useIntl } from "react-intl";
import AnimatedModal from "components/AnimateModal/AnimateModal";
import styles from "./compatibleModal.module.scss";
import { FilePreviewCrossIcon } from "pages/Workspaces/components/icons/CrossIcon";
import { useState, useEffect, useRef } from "react";
import { DropDown } from "components";
import { IChatModel, setChatModel, startNewChat, SaveSelectedThread,  selectedThread, IUser, EmptyChatContent, IFileS3Link , removeMultipleChat, deleteSingleChatHistory, DeleteS3Link, setRememberChatTopic} from "redux/actions";
import {
    ChatRoute,
    IUploadFile
} from "pages/ChatPage/ChatPage";
import useRouter from "hooks/useRouter";
import { RoutePaths } from "pages/routePaths";
import { imgURL } from "utils/constants";
import useChat from "hooks/services/ChatServices/useChat";

interface IProp {
    openCompatibleModel: boolean;
    onClose: () => void;
    onSendMessage?: (
        question: string,
        chatModels?: IChatModel,
        regenerate?: boolean,
        images?: IFileS3Link[],
        // string[],
        filePath?: IFileS3Link[],
        // string[],
        ws_id?: string,
        newPage?: boolean,
    ) => void;
    uploadingFiles?: IUploadFile[];
    // message: string;
    url?: string;
  fileS3Link?: string[];
}

export const CompatibleModal = ({ openCompatibleModel, onClose, onSendMessage, uploadingFiles, url, fileS3Link }: IProp) => {
    const dropdownRef = useRef<HTMLDivElement>(null);
    const { formatMessage } = useIntl();
    const { theme, userDetail } = useSelector((state) => state.authReducer);
    const { chatModels } = useSelector((state) => state.chatModelsReducer);
    const { filterModel, PrivateChat } = useSelector((state) => state.chatReducer);
    const {fData, newChatThread} =  useSelector((state) => state.workSpaceReducer);
    const {
        push, pathname
    } = useRouter();

    const compatibleModels = chatModels.filter(model => model.type.includes(filterModel));
    const { getReaminingCredits } = useChat();

    const [option, setOption] = useState<string>("new"); // "continue" or "new"
    const [selectedModelId, setSelectedModelId] = useState<number>(compatibleModels.length > 0 ? compatibleModels[0].id : 0);
    const [selectedModelName, setSelectedModelName] = useState<string>(
        compatibleModels.length > 0 ? compatibleModels[0].name : ""
    );
    const workspaceId = pathname.split("/")[2];

    // Ensure we have a valid selection when chatModels changes
    useEffect(() => {
        if (compatibleModels.length > 0 && !compatibleModels.some(model => model.id === selectedModelId)) {
            setSelectedModelId(compatibleModels[0].id);
            setSelectedModelName(compatibleModels[0].name);
        }
    }, [compatibleModels, selectedModelId]);

    const handleOptionChange = (optionType: string) => {
        setOption(optionType);
    };

    // Convert chatModels to dropdown options format

    const dropdownOptions = compatibleModels.map(model => {
        return {
            label: model.name,
            value: model.name,
            description: model?.attributes?.short_description
        };
    });

    // Function to handle model selection via DropDown
    const handleDropdownChange = (option: { value: string; label: string }) => {
        // Find the model by name instead of ID
        const selectedModel = compatibleModels.find(model => model.name === option.value);
        if (selectedModel) {
            setSelectedModelId(selectedModel.id);
            setSelectedModelName(selectedModel.name);
        }
    };
    const handleDeleteS3Link = () => {
        fileS3Link?.map((file) => {
          DeleteS3Link(file);
        });
      };
    const handleContinue = () => {
        const selectedModel = compatibleModels.find(model => model.id === selectedModelId);
        const InSufficientCredits =  Number(selectedModel?.credits_per_message) >
        (userDetail?.user as IUser).activeSubscription.credits ||
        getReaminingCredits() <= 0; 
        if (selectedModel) {
            if(!InSufficientCredits) {
            setChatModel(selectedModel);
            localStorage.setItem('GptModel', JSON.stringify(selectedModel));
            if (filterModel === "document") {
                localStorage.setItem('documentChatGptModel', JSON.stringify(selectedModel));
            } else {
                localStorage.setItem('imageChatGptModel', JSON.stringify(selectedModel));
            }
        }
            if (option === "new") {
                  const SaveThreadInfo: selectedThread = {
                      ws_name: "",
                      emoji: "",
                      thread_name: "",
                      thread_id: 0,
                      ws_id: 0,
                    };
                    SaveSelectedThread(SaveThreadInfo);
                    if(!InSufficientCredits) {
                        setTimeout(() => {
                            if (newChatThread.id) { push(`/${RoutePaths.Workspaces}/${workspaceId}/thread`); }
                            else {
                                push(`/${RoutePaths.Chat}/${ChatRoute.New}`);
                            }
                        }, 0);
                    }
                const urlExtension = url?.split('.').pop()?.toLowerCase() || '';
                const isImageUrl = imgURL.includes(urlExtension);

                // Process files and send message in the new chat
                const imageFiles = uploadingFiles?.filter(file => file.fileType === "image") || [];
                const docFiles = uploadingFiles?.filter(
                    file => ["document", "video", "audio"].includes(file.fileType || "")
                ) || [];

                // Extract S3 links for each type
                const imageS3Links = imageFiles
                    .map(file => file.S3Link)
                    .filter((link): link is string => link !== undefined);

                const docS3Links = docFiles
                    .map(file => file.S3Link)
                    .filter((link): link is string => link !== undefined);

                if (url) {
                    if (isImageUrl) {
                        imageS3Links.push(url);
                    } else {
                        docS3Links.push(url);
                    }
                }

                startNewChat();
                EmptyChatContent();
                setRememberChatTopic("");
                if(PrivateChat){
                    const currentPath = window.location.pathname;
                    const pathSegments = currentPath.split("/");
                    const chatIdFromUrl = pathSegments[pathSegments.length - 2];
                
                    if (Number(chatIdFromUrl)) {
                      deleteSingleChatHistory(Number(chatIdFromUrl));
                      removeMultipleChat([Number(chatIdFromUrl)]);
                      sessionStorage.removeItem("privateChatActive");
                      sessionStorage.removeItem("PrivateChatId");
                    }
                
                    sessionStorage.setItem("privateChatActive", JSON.stringify(true));
                    localStorage.setItem("previousPrivateChat", JSON.stringify(true));
                    handleDeleteS3Link();
                }
                onSendMessage?.(
                    fData.question,
                    selectedModel,
                    false,
                    fData.images,
                    fData.filePath,
                    "",
                    (option === "new") ? true : false,
                );
                setTimeout(() => { onClose() }, 10);
            } else {
                const urlExtension = url?.split('.').pop()?.toLowerCase() || '';
                const isImageUrl = imgURL.includes(urlExtension);
                const imageFiles = uploadingFiles?.filter(file => file.fileType === "image") || [];
                const docFiles = uploadingFiles?.filter(
                    file => ["document", "video", "audio"].includes(file.fileType || "")
                ) || [];
                // Extract S3 links for each type
                const imageS3Links = imageFiles
                    .map(file => file.S3Link)
                    .filter((link): link is string => link !== undefined);

                const docS3Links = docFiles
                    .map(file => file.S3Link)
                    .filter((link): link is string => link !== undefined);
                if (url) {
                    if (isImageUrl) {
                        imageS3Links.push(url);
                    } else {
                        docS3Links.push(url);
                    }
                }
                onSendMessage?.(
                    fData.question,
                    selectedModel,
                    false,
                    fData.images,
                    fData.filePath,
                );
                onClose();
            }
        }
    };

    const fileType= filterModel === "image_chat"? "image": filterModel;

    return (
        <AnimatedModal
            compatibility={true}
            isOpen={openCompatibleModel}
            onClose={() => onClose?.()}
        >
            <div className="flex items-center justify-between">
                <div
                    className={classNames("font-inter", styles.modalHead, {
                        [styles.light]: theme === "light",
                        [styles.dark]: theme === "dark",
                    })}
                >
                    <FormattedMessage id="compatible.model.head" />
                </div>
                <div onClick={onClose} className="cursor-pointer">
                    <FilePreviewCrossIcon />
                </div>
            </div>
            <div className={`font-inter py-3 ${styles.modalTitle}`}>
                <FormattedMessage id="compatible.model.title" values={{ file: fileType}}/>
            </div>
            <div className={classNames(styles.optionsContainer, {
                [styles.active]: option === "continue"
            })}>
                <div className="flex gap-2">
                    <label className={styles.checkboxContainer}>
                        <input
                            type="checkbox"
                            checked={option === "continue"}
                            onChange={() => handleOptionChange("continue")}
                        />
                        <span className={styles.checkmark}></span>
                    </label>
                    <div>
                        <span className={classNames("font-inter", styles.OptionHead, {
                            [styles.light]: theme === "light",
                            [styles.dark]: theme === "dark"
                        })}> <FormattedMessage id="compatible.model.option1" /> </span>
                        <div>
                            <span className={classNames("font-inter", styles.OptionTitle)}> <FormattedMessage id="compatible.model.option1.title" /> </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className={classNames("mt-2", styles.optionsContainer, {
                [styles.active]: option === "new"
            })}>
                <div className="flex gap-2">
                    <label className={styles.checkboxContainer}>
                        <input
                            type="checkbox"
                            checked={option === "new"}
                            onChange={() => handleOptionChange("new")}
                        />
                        <span className={styles.checkmark}></span>
                    </label>
                    <div>
                        <span className={classNames("font-inter", styles.OptionHead, {
                            [styles.light]: theme === "light",
                            [styles.dark]: theme === "dark"
                        })}> <FormattedMessage id="compatible.model.option2" /> </span>
                        <div>
                            <span className={classNames("font-inter", styles.OptionTitle)}> <FormattedMessage id="compatible.model.option2.title" /> </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className={classNames("font-inter mt-[18px]", styles.selectLabel, {
                [styles.light]: theme === "light",
                [styles.dark]: theme === "dark",
            })}>
                <FormattedMessage id="compatible.model.select" />
            </div>

            <div className={styles.selectContainer} ref={dropdownRef}>
                <DropDown
                    $background={theme === "light" ? "#fff" : "transparent"}
                    variant={theme}
                    height={40}
                    className={classNames(styles.select, {
                        [styles.light]: theme === "light",
                        [styles.dark]: theme === "dark",
                    })}
                    value={selectedModelName}
                    options={dropdownOptions}
                    placeholder={formatMessage({
                        id: "compatible.model.select.placeholder",
                        defaultMessage: "Select a model"
                    })}
                    onChange={handleDropdownChange}
                    compatibleMod={true}
                />
            </div>

            <div className="flex justify-end mt-4">
                <button
                    className={styles.continueButton}
                    onClick={handleContinue}
                // Add your continue handler here
                >
                    <span className={classNames("font-inter", styles.continue)}> <FormattedMessage id="creditLimit.modal.continueBtn.text" /> </span>
                </button>
            </div>
        </AnimatedModal>
    );
};
